import { DetailedHTMLProps, HTMLAttributes } from 'react';

import { TImageValue } from '../../ImageList';

import { ImageListRow } from './components';

import styles from '../styles/ImageListValue.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	baseUrl: string;
	files: TImageValue[];
	show: (src: string, name: string) => void;
};

export function ImageListValue(props: TProps) {
	const {
		baseUrl,
		show,
		files = [],
	} = props;

	if (files.length <= 0) {
		return (
			<></>
		);
	}

	const classNames = [styles.list];

	return (
		<div className={ classNames.join(' ') }>
			{
				files.map(item => {
					return (
						<ImageListRow
							key={ item.path }
							baseUrl={ baseUrl }
							file={ item }
							show={ show }
							tabIndex={ -1 }
						/>
					);
				})
			}
		</div>
	);
}
